import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/login'
import Layout from '@/views/layout'
import Search from '@/views/search'
import SearchList from '@/views/search/list'

import accessRecord from '@/views/accessRecord'
import routeList from '@/views/routeList'
import dormAccess from '@/views/dormAccess'
import queryScore from '@/views/queryScore'
import childrenInfo from '@/views/childrenInfo'
import feedback from '@/views/feedback'
import  changePassword from '@/views/changePassword'

import Home from '@/views/layout/home'
import Thome from '@/views/layout/thome'
import Book from '@/views/layout/book'
import User from '@/views/layout/user'
import store from '@/store'

//教师账号
import stuGetAccessList from '@/views/teacher/students/accessRecords'
import zouduGetAttendancData from '@/views/teacher/students/zouduAccessRecords'
import zhuduGetAttendancData from '@/views/teacher/students/zhuduAccessRecords.vue'
import detail_list from '@/views/teacher/students/detail_list.vue'
import fenceRoute from '@/views/teacher/students/fenceRoute.vue'

import DormSignin from '@/views/teacher/class/dormSignin.vue'
import Attendance from '@/views/teacher/class/attendance.vue'
import Publish from '@/views/teacher/class/publish.vue'

import Schoolbook from '@/views/teacher/book/school.vue'
import Parentbook from '@/views/teacher/book/parent.vue'

import selectTeacher from '@/views/teacher/class/school.vue'
import selectParents from '@/views/teacher/class/parent.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
 return originalPush.call(this, location).catch(err => err)
}
//缓存获取用户角色
let redirect = '/home'
let userinfo = localStorage.getItem('userinfo')
// console.log('userinfo', userinfo)
if (userinfo) {
  userinfo = JSON.parse(userinfo)
  if (userinfo.identify == 'teacher') {
    redirect = '/thome'
  }
}
// console.log('redirect', redirect)
const router = new VueRouter({
  routes: [
    { path: '/login', component: Login },
    {
      path: '/',
      component: Layout,
      redirect: redirect,
      children: [
        { path: '/home', component: Home },
        { path: '/thome', component: Thome },
        { path: '/book', component: Book },
        { path: '/user', component: User }
      ]
    },
    { path: '/search', component: Search },
    { path: '/searchlist', component: SearchList },

    { path: '/accessRecord', component: accessRecord },
    { path: '/routeList', component: routeList },
    { path: '/dormAccess', component: dormAccess },
    { path: '/queryScore', component: queryScore },
    { path: '/childrenInfo', component: childrenInfo },
    { path: '/feedback', component: feedback },
    { path: '/changePassword', component: changePassword },

    //教师账号
    { path: '/stuGetAccessList', component: stuGetAccessList },
    { path: '/zouduGetAttendancData', component: zouduGetAttendancData },
    { path: '/zhuduGetAttendancData', component: zhuduGetAttendancData },
    { path: '/detail_list', component: detail_list },
    { path: '/fenceRoute', component: fenceRoute },

    { path: '/dormSignin', component: DormSignin },
    { path: '/attendance', component: Attendance },
    { path: '/publish', component: Publish },
    { path: '/schoolbook', component: Schoolbook },
    { path: '/parentbook', component: Parentbook },
    { path: '/selectteacher', component: selectTeacher },
    { path: '/selectparents', component: selectParents }
  ]
})

const authUrls = 
  [ '/accessRecord', '/routeList', '/dormAccess', '/queryScore', 
    '/childrenInfo', '/feedback', '/changePassword', '/stuGetAccessList',
    '/zouduGetAttendancData', '/zhuduGetAttendancData', '/detail_list',
    '/fenceRoute', '/dormSignin', '/attendance', '/schoolbook', '/parentbook',
    '/selectteacher', '/selectparents'
  ]

router.beforeEach((to, from, next) => {
  if (!authUrls.includes(to.path)) {
    next()
    return
  }

  const token = store.getters.token
  if (token) {
    next()
  } else {
    next('/login')
  }
})

export default router
